module.exports = __webpack_public_path__ + "market/static/img/beij.e1b55a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/award/beij.jpg
// module id = SIJq
// module chunks = 1